// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__39G6r","title":"AfterBackImages_title__xRZTM","images":"AfterBackImages_images__1Jem4"};